export default __webpack_public_path__ + "static/media/fracture.5131f2e1.jpg";